import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cce8f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "createPlan" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "设置回访计划", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { createVisit } from "../../config/interface";
import type { ElForm } from "element-plus";
import { ElMessage } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formRef = ref<FormInstance>();
const router = useRouter();
const route = useRoute();
const token = JSON.parse(localStorage.getItem('ACCESS_TOKEN') as string) || '';
let back = "<";
// 临时存放计划信息
const planInfo = reactive({
  plan: [
    {
      date: "",
    },
  ],
});
// 点击新增按钮，添加一条计划
const addPlan = () => {
  planInfo.plan.push({
    date: "",
  });
};
// 点击删除按钮，移除对应的一条计划
const removePlan = (item: any) => {
  const index = planInfo.plan.indexOf(item);
  if (index !== -1) {
    planInfo.plan.splice(index, 1);
  }
};
// 点击提交按钮，请求接口
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log("submit!", planInfo);
      let visitDay = [] as any;
      planInfo.plan.map((item) => {
        visitDay.push(item.date);
      });
			console.log(token);
			
      let params = {
        coId: route.query.coId,
				type: route.query.type,
        visitDay,
        userId: token.id,
				authority: token.authority
      };
      console.log(params);
      createVisit(params).then((res) => {
        console.log(res);
				if(res.data.data && res.data.success) {
					ElMessage.success(res.data.msg)
					router.back();
				} else {
					ElMessage.error(res.data.msg)
				}
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
const handleBack = () => {
  router.back();
};
onMounted(() => {
  console.log(route.query);
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _hoisted_3,
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: _unref(planInfo)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(planInfo).plan, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            key: index,
            label: '回访时间' + (index + 1),
            prop: 'plan.' + index + '.date',
            rules: {
          required: true,
          message: '请选择回访时间',
          trigger: 'change'
        }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: item.date,
                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                type: "date",
                format: "YYYY/MM/DD",
                "value-format": "YYYY-MM-DD",
                placeholder: "请选择回访时间"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_button, {
                type: "danger",
                style: {"margin-left":"10px"},
                onClick: _withModifiers(($event: any) => (removePlan(item)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1032, ["label", "prop"]))
        }), 128)),
        _createVNode(_component_el_form_item, { prop: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: addPlan }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (submitForm(formRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})